module.exports = __webpack_public_path__ + "static/media/introduction-03.239b060a.png";